import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { IncidentsGridDataProviderFactory } from '../factory/IncidentsGridDataProviderFactory';
import { IncidentsGridBaseDataProvider } from '../dataProvider/IncidentsGridBaseDataProvider';
import { IncidentsGridWebComponentSchema } from '../types';

export class IncidentsGridRepository extends BaseWebComponentRepository {
  public dataProviderFactory: IncidentsGridDataProviderFactory;
  public dataProvider: IncidentsGridBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new IncidentsGridDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<IncidentsGridWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }
}
